import React from 'react'

const Social = () => {
    return (
       <div className="home__social">
        <a href="https://www.avanish.dev" className="home__social-icon" target="_blank">
            <i class="uil uil-instagram-alt"></i>
        </a>

        <a href="https://www.avanish.dev" className="home__social-icon" target="_blank">
             <i class="uil uil-dribbble"></i>
        </a>
        
        <a href="https://www.avanish.dev" className="home__social-icon" target="_blank">
            <i class="uil uil-github-alt"></i>
        </a>

       </div>
    )
}

export default Social